<template>
  <div class="login-layout">
    <header class="login-layout__header">
      <auth-header-block>
        <router-link-to
          default_button
          :route_name="route_names.login">
          {{ $t('auth.have_account') }}
        </router-link-to>
      </auth-header-block>
    </header>
    <div class="login-layout__main">
      <div class="login-layout__main-inner">
        <h4>{{ $t('auth.register') }}</h4>
        <gray-text class="mt-10">
          {{ $t('auth.enter_your_email_and_password_to_sign_up') }}
        </gray-text>
        <hr class="my-30"/>
        <ValidationObserver v-slot="{ invalid, passes }" ref="form">
        <default-form
          ref="form"
          @submit.prevent="passes(submitForm)">
          <div class="row row-gap-10">
            <div class="col-sm-6 col-12">
              <default-input
                class="mt-10"
                :label="$t('inputs.name')"
                name="name"
                placeholder="Minimum 8 characters"
                required
                v-model="auth_user.name"
              />
            </div>
            <div class="col-sm-6 col-12">
              <default-input
                class="mt-10"
                :label="$t('inputs.surname')"
                name="surname"
                placeholder="Minimum 8 characters"
                required
                v-model="auth_user.surname"
              />
            </div>
            <div class="col-12">
              <default-input
                class="mt-10"
                :label="$t('inputs.email')"
                name="email"
                placeholder="Minimum 8 characters"
                required
                v-model="auth_user.email"
              />
            </div>
            <div class="col-sm-6 col-12">
              <default-input
                class="mt-10"
                :label="$t('inputs.password')"
                type="password"
                placeholder="Minimum 8 characters"
                required
                v-model="auth_user.password"
              />
            </div>
            <div class="col-sm-6 col-12">
              <default-input
                class="mt-10"
                :label="$t('user.confirm_password')"
                type="password"
                name="password_confirm"
                placeholder="Minimum 8 characters"
                required
                v-model="auth_user.password_confirmation"
              />
            </div>
          </div>
          <info-block
            v-if="response_message"
            :success="!response_error"
            :error="response_error"
            class="mt-20">
            {{ response_message }}
          </info-block>
          <div class="mt-20">
            <default-button
              class="w-100">
              {{ $t('auth.create_my_account') }}
            </default-button>
          </div>

          <div class="mt-20">
            {{ $t('auth.already_a_member') }}
            <router-link-to
              class="fw-600"
              :route_name="route_names.login">
              {{ $t('auth.sign_in') }}
            </router-link-to>
          </div>
        </default-form>
        </ValidationObserver>
      </div>
    </div>
    <loader v-if="loading"/>
  </div>
</template>

<script>

import GrayText from "../../small_components/GrayText.vue";
import DefaultButton from "../../small_components/DefaultButton.vue";
import InfoBlock from "../../small_components/InfoBlock.vue";
import DefaultInput from "../../small_components/DefaultInput.vue";
import {GO_TO_VERIFY_EMAIL} from "../../../router";
import {axiosAuth} from "../../../helpers/axios_requests";
import Loader from "../../small_components/Loader.vue";
import {mapActions, mapGetters} from "vuex";
import AuthHeaderBlock from "../../parts/AuthHeaderBlock.vue";
import RouterLinkTo from "../../small_components/RouterLinkTo.vue";
import routes_mixin from "../../../mixins/routes_mixin";
import DefaultForm from "../../small_components/form-parts/DefaultForm.vue";
import {FORMAT_ERROR_MESSAGE} from "../../../helpers/validation_error_message";
import {STATUS_ERROR} from "../../../store/modules/notifiocation";
import {ValidationObserver} from "vee-validate";

export default {
  name: 'RegisterLayout',
  mixins: [routes_mixin],
  components: {
    DefaultForm,
    RouterLinkTo,
    AuthHeaderBlock,
    Loader,
    DefaultInput,
    InfoBlock,
    DefaultButton,
    GrayText,
    ValidationObserver
  },
  computed: {
    ...mapGetters([
      'getUserMailVerified'
    ]),
  },
  data() {
    return {
      show_error: false,
      auth_user: {
        name: '',
        surname: '',
        email: '',
        password: '',
        password_confirmation: '',
      },
      response_error: false,
      response_message: '',
      loading: false
    }
  },
  methods: {
    ...mapActions([
      'actionSetUser',
      'actionSetUserToken',
      'actionChangeNotifications',
      'actionPushNotification'
    ]),
    submitForm() {
      this.loading = true
      this.response_error = false
      this.response_message = ''
      axiosAuth.register(this.auth_user)
        .then(({data}) => {
          if (data.errors) {
            this.$refs.form.setErrors(data.errors);
            let message = FORMAT_ERROR_MESSAGE(data.errors)
            this.actionPushNotification(
                {message: message, status: STATUS_ERROR}
            )
            return;
          }
          this.actionSetUser(data.user || null)
          this.actionSetUserToken(data.token || null)
          this.actionChangeNotifications()

          if (!data.user) return
          if (!this.getUserMailVerified) {
            return GO_TO_VERIFY_EMAIL()
          }
          if (this.$route.query && this.$route.query.from_page) {
            this.$router.push({path: decodeURIComponent(this.$route.query.from_page)})
          } else {
          }
        }).catch(e => {
          console.log(e);
          this.response_message = e.response?.data.error || e.response?.data.message
          this.response_error = true
        }).finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
